export interface IIntakePetSectionQuestionListValue {
    intakePetSectionQuestionListValueId: number;
    intakePetSectionQuestionId: number;
    name: string;
    sortOrder: number;
    isSelected: boolean;
    storage: string;
}

export class IntakePetSectionQuestionListValue implements IIntakePetSectionQuestionListValue {
    intakePetSectionQuestionListValueId: number;
    intakePetSectionQuestionId: number;
    name: string;
    sortOrder: number;
    isSelected: boolean;
    storage: string;

    constructor(params: Partial<IIntakePetSectionQuestionListValue> = {}) {
        const {
            intakePetSectionQuestionListValueId = 0,
            intakePetSectionQuestionId = 0,
            name = '',
            sortOrder = 0,
            isSelected = false,
            storage = ''
        } = params;

        this.intakePetSectionQuestionListValueId = intakePetSectionQuestionListValueId;
        this.intakePetSectionQuestionId = intakePetSectionQuestionId;
        this.name = name;
        this.sortOrder = sortOrder;
        this.isSelected = isSelected;
        this.storage = storage;
    }
}
